import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Container, PageFade, Reveal } from "../components/site/Motion";
import { FaqAccordion, PageHeader } from "../components/site/Sections";

export default function RessourcesFaq() {
  return (
    <PageFade>
      <PageHeader eyebrow="Ressources et FAQ" title="Vos questions," accent="nos réponses.">
        <p className="max-w-2xl text-lg text-[#242020]/80">Des réponses simples et prudentes aux questions les plus fréquentes. Pour une analyse de votre situation, la première consultation est gratuite.</p>
      </PageHeader>
      <Container className="max-w-4xl py-16">
        <Reveal><FaqAccordion /></Reveal>
        <div className="mt-12 flex flex-wrap gap-4">
          <Link to="/plans-educatifs" className="btn-outline" data-testid="faq-resources-link">Bibliothèque de ressources</Link>
          <Link to="/consultation" className="btn-primary" data-testid="faq-consultation-link">Prendre rendez-vous <ArrowRight className="h-4 w-4" /></Link>
        </div>
      </Container>
    </PageFade>
  );
}
